import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { VisualContentOptions, VisualExperience } from 'amazon-quicksight-embedding-sdk/dist/index';

@Component({
  selector: 'app-quicksight-visual-display',
  templateUrl: './quicksight-visual-display.component.html',
  styleUrl: './quicksight-visual-display.component.scss',
  standalone: false
})
export class QuicksightVisualDisplayComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() embedUrl: string;
  @Input() visualContentOptions: VisualContentOptions = {};

  @ViewChild('qsVisualContainer', { static: true }) qsVisualContainer: ElementRef;

  embeddingContext: any;
  visualExperience: VisualExperience;

  ngAfterViewInit(): void {
    if (this.embedUrl) {
      this.loadEmbed();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['embedUrl'] && !changes['embedUrl'].firstChange) {
      this.loadEmbed();
    }
  }

  ngOnDestroy(): void {
    const elems = Array.from(document.getElementsByClassName('quicksight-embedding-iframe'));
    for (let el of elems) {
      el.remove();
    }
  }

  async loadEmbed() {
    if (!this.embedUrl || !this.qsVisualContainer) return;

    this.qsVisualContainer.nativeElement.innerHTML = '';

    const frameOptions = {
      container: this.qsVisualContainer.nativeElement,
      url: this.embedUrl,
      className: 'qs-visual',
      resizeHeightOnSizeChangedEvent: true,
    };

    this.embeddingContext = await createEmbeddingContext();
    this.visualExperience = await this.embeddingContext.embedVisual(frameOptions, this.visualContentOptions);
  }

}
